import { onMounted, computed } from "vue"
import { useMenuStore } from "stores/menu.store"
import { useMainStore } from "stores/main.store"
import MenuSearch from '../MenuSearch/MenuSearch.vue'
import menuAccessibility from "../menu-accessibility"

export default {
    name: 'MenuPrimary',
    components: {
        MenuSearch,
    },
    setup() {
        const ACTIVE_MENU_MODIFIER = 'be-menu-primary__menu-list-item--active'
        const ACTIVE_REGION_MODIFIER = 'be-region-overlay__menu-list-item--active'

        const handleRegionItem = (regionItemToActivate) => {
            menuStore.setActiveRegion(regionItemToActivate)
        }

        const getRegionClassnameModifiers = (regionItemToActivate) => {
            regionItemToActivate === activeRegion.value ? ACTIVE_REGION_MODIFIER : ''
        }

        const mainStore = useMainStore()
        const menuStore = useMenuStore()
        const activeMenu = computed(() => menuStore.activeMenu)
        const activeRegion = computed(() => menuStore.activeRegion)

        const closeMenu = () => menuStore.closeMenu()

        const getClassnameCover = () => {
            const showCoverClassname = menuStore.isOverlayOpen ? 'be-menu-primary__cover--visible' : ''
            const coverTransparent = menuStore.isCoverTranparent ? ' be-menu-primary__cover--transparent' : ''
            return showCoverClassname + coverTransparent
        }
        const getClassnameModifiers = (menuItemToActivate) => (menuItemToActivate === activeMenu.value ? ACTIVE_MENU_MODIFIER : '')
        
        const handleMenuItem = (menuItemToActivate) => {
            // if on the search page, disable the search overlay

            if (window.innerWidth < mainStore.breakpoints.tablet) {
                mainStore.changeOverlaySettings({showOverlay: true, overlayType: "mainMenu", content: {}})

                setTimeout(() => {
                    const mobileOverlayRegion = document.querySelector('.be-region-overlay-mobile')
                    const firstInteractiveElement = mobileOverlayRegion?.querySelector('.be-js--mobile-menu-item')
                    firstInteractiveElement?.focus()
                }, 50)
            }

            const staticSearchBar = document.querySelector('.be-js-static-search-bar')
            if ((menuItemToActivate === 'search' && !staticSearchBar) || menuItemToActivate !== 'search') {
                menuStore.setActiveMenu(menuItemToActivate)
            }
        }

        const isActiveMenu = function (activeMenuName, onlyBoolean) {
            const state = activeMenuName === activeMenu.value ? 'be-menu-primary__mega-menu--shown' : ''
            return onlyBoolean ? !!state : state
        }

        const isActiveAction = function (activeActionName, onlyBoolean) {
            const state = activeActionName === activeMenu.value ? 'be-menu-primary__action--shown' : ''
            return onlyBoolean ? !!state : state
        }

        const handleBurgerMenu = function () {
            mainStore.changeOverlaySettings({showOverlay: true, overlayType: "mainMenu", content: {}})
            setTimeout(() => {
                const overlay = document.querySelector('.be-overlay[data-type="mainMenu"]')
                const overlayFirstLink = overlay?.querySelector('.be-js--mobile-menu-item')
                overlayFirstLink?.focus()
            }, 50)
        }

        const activateLanguageSelectorOverlay = function (langugeSelectorContent) {
            mainStore.changeOverlaySettings(
                {
                  showOverlay: true, 
                  overlayType: "prompt",  
                  titleText: langugeSelectorContent.title, 
                  content: {
                      htmlString: langugeSelectorContent.htmlString,
                      }
                }
            )
        }

        onMounted(() => {
            setTimeout(() => { 
                menuAccessibility()
            }, 100)
            
            document.body.addEventListener('keyup', (e) => {
                if (e.code === 'Escape') {
                    // close desktop menu
                    closeMenu()
                    // close overlay mobile menu
                    mainStore.clearOverlay()
                    const overlay = document.querySelector('.be-overlay')
                    overlay?.close()
                }
            })

            // we need to avoid showing the mega menu on mobile sizes
            window.addEventListener('resize', () => {
                const breakpointTablet = mainStore.breakpoints.tablet
                if (window.innerWidth <= breakpointTablet ) {
                    closeMenu()
                }
            })
        })

        return {
            getClassnameCover,
            getClassnameModifiers,
            handleBurgerMenu,
            handleMenuItem,
            isActiveMenu,
            isActiveAction,
            closeMenu,
            getRegionClassnameModifiers,
            handleRegionItem,
            activateLanguageSelectorOverlay,
        }
    },
}
